<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="
              md-layout-item
              md-size-33
              md-small-size-66
              md-xsmall-size-100
              md-medium-size-40
              mx-auto
            "
          >
            <div>
              <md-card>
                <md-card-header
                  style="background: linear-gradient(80deg,#f95050,#1818fa);"
                >
                  <h3 style="text-align:center" class="stitle">
                    Bonjour
                    <b>{{ this.user.nom + " " + this.user.prenom }}</b> Nous
                    sommes le <b>{{ new Date().toLocaleDateString() }}</b>
                  </h3>
                </md-card-header>
                <md-card-content>
                  <div class="layout text-center">
                    <div class="layout md-size-66 mx-auto">
                      <md-button
                        class=" md-danger md-round"
                        color="red"
                        href="#/session"
                        >Nouvelle mission</md-button
                      >
                      <md-button
                        class="md-danger md-round"
                        href="#/listeUnBenevole"
                        >Heures de bénévolat</md-button
                      >
                      <md-button
                        class="md-danger md-round"
                        href="#/volunteer"
                        v-if="
                          ($store.getters.isAuthenticated &&
                            $store.getters.user.typeutilisateur == 'Admin')
                        "
                        >Heures par utilisateur</md-button
                      >
                      <md-button
                        class="md-danger md-round"
                        href="#/listeParAntenne"
                        v-if="
                          $store.getters.isAuthenticated &&
                            $store.getters.user.typeutilisateur == 'Admin'
                        "
                        >Heures par antenne</md-button
                      >
                      <md-button
                        class="md-danger md-round"
                        href="#/listeParActivite"
                        v-if="
                          $store.getters.isAuthenticated &&
                            $store.getters.user.typeutilisateur == 'Admin'
                        "
                        >Heures par activite</md-button
                      >
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  bodyClass: "login-page",
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  computed: {
    ...mapGetters(["user"]),

    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="css"></style>
